import numeral from 'numeral';
import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { DateTime } from 'luxon';
import DetailField from '../ReusableComponents/DetailField/DetailField';
import Link from '../ReusableComponents/Link/Link';
import styles from './VendorBillDetail.module.css';
import historyProps from '../../Lib/Utils/PropTypes/history-props';
import matchProps from '../../Lib/Utils/PropTypes/match-props';
import { ReactComponent as PrevSVG } from '../../Assets/icons/prev.svg';
import Page from '../Page/index.ts';
import Header from '../Header/index.ts';
import VendorBillDetailDataGrid from './VendorBillDetailDataGrid.tsx';

class VendorBillDetail extends Component {
  constructor(props) {
    super(props);

    const {
      getVendorBill,
      match: {
        params: { id, vendorBillId },
      },
    } = this.props;

    this.handleBackClick = this.handleBackClick.bind(this);

    getVendorBill(id, vendorBillId);
  }

  handleBackClick() {
    const { history, match } = this.props;
    const userId = match.params.id;
    if (history.length > 2) {
      history.goBack();
    } else {
      history.push(`/users/${userId}/invoices`);
    }
  }

  render() {
    const {
      vendorBill: {
        items,
        invoice_number,
        po_internal_id,
        po_number,
        due_date,
        discount_date,
        discount_amount,
        terms,
        status,
        total,
      },
      match: {
        params: { id },
      },
    } = this.props;

    if (!invoice_number) {
      return null;
    }

    return (
      <Page.Container>
        <Header.Major
          icon="bank"
          title="Invoices"
          subTitle={invoice_number}
          onCloseLink={`/users/${id}/invoices`}
        />
        <Page.Content>
          <span className="text-xl font-semibold">{`#${invoice_number}`}</span>
          <div className={styles.row}>
            <DetailField label="Applies To:" id="vbd-po-number">
              <span className={styles.poNumberLink}>
                <Link to={`/users/${id}/purchase-orders/${po_internal_id}`}>
                  {po_number}
                </Link>
              </span>
            </DetailField>
            <DetailField label="Status" id="vbd-status">
              <span>{status}</span>
            </DetailField>
            <DetailField label="Total" id="vbd-total">
              <span>{numeral(total).format('$0,0.00')}</span>
            </DetailField>
            <div />
          </div>

          <div className={styles.row}>
            <DetailField label="Due Date:" id="vbd-due-date">
              <span>
                {due_date
                  ? DateTime.fromISO(due_date, { zone: 'utc' }).toFormat(
                      'MM/dd/yy',
                    )
                  : ''}
              </span>
            </DetailField>
            <DetailField label="Terms:" id="vbd-terms">
              <span>{terms}</span>
            </DetailField>
            <DetailField label="Discount Date:" id="vbd-discount-date">
              <span>
                {discount_date
                  ? DateTime.fromISO(discount_date, { zone: 'utc' }).toFormat(
                      'MM/dd/yy',
                    )
                  : ''}
              </span>
            </DetailField>
            <DetailField label="Discount Amount:" id="vbd-discount-amount">
              <span>
                {discount_amount
                  ? numeral(discount_amount).format('$0,0.00')
                  : ''}
              </span>
            </DetailField>
          </div>

          <VendorBillDetailDataGrid rows={items} />

          <div className={styles.buttonRow}>
            <PrevSVG
              height="15"
              width="40"
              className={styles.buttonPreviousSvg}
              onClick={this.handleBackClick}
            />
            {/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions,jsx-a11y/click-events-have-key-events */}
            <p
              id="vbd-detail-back"
              className={styles.buttonPrevious}
              onClick={this.handleBackClick}
            >
              PREVIOUS
            </p>
          </div>
        </Page.Content>
      </Page.Container>
    );
  }
}

VendorBillDetail.propTypes = {
  history: historyProps.isRequired,
  match: matchProps.isRequired,
  vendorBill: PropTypes.shape({}).isRequired,
  getVendorBill: PropTypes.func.isRequired,
};

export default VendorBillDetail;
